import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

export const useRouteTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const pageTitle = getPageTitle(location.pathname);
    trackPageView(location.pathname + location.search, pageTitle);
  }, [location]);
};

const getPageTitle = (pathname: string): string => {
  switch (pathname) {
    case '/':
      return 'Home - ChordRacer';
    case '/practice':
      return 'Practice - ChordRacer';
    default:
      return 'ChordRacer';
  }
};
